import { format } from 'date-fns'
import * as React from 'react'
import DayPicker from 'react-day-picker'
import TimeSelector from '../ui/TimeSelector'

export interface ISelectDateProps {
  title: string
  selectedDay: any
  handleDayClick: (selectedDay: any, modifiers: any) => void
  handleClose: () => void
  handleApply: () => void
}

export interface ISelectDateState {
  hours: number
  minutes: number
}

class SelectDate extends React.Component<ISelectDateProps, ISelectDateState> {
  constructor(props: ISelectDateProps) {
    super(props)
    this.state = {
      hours: 10,
      minutes: 30
    }
  }

  public render() {
    return (
      <div className='absolute z2 top1 flex bg-white w415'>
        <div className='col-4 py2 pl3'>
          <div>{this.props.title}</div>
          <div className='h6 font-grey2'>{format(this.props.selectedDay, 'MMMM DD, YYYY')}</div>
          <TimeSelector hours={this.state.hours} minutes={this.state.minutes} onTimeChanged={this.handleTimeChanged} />
        </div>
        <div className='col-8 bg-light-grey3 py2'>
          <DayPicker
            onDayClick={this.props.handleDayClick}
            selectedDays={this.props.selectedDay}
            showOutsideDays={true}
            disabledDays={[{ before: new Date() }]}
          />
          <div className='flex justify-end px2'>
            <div className='p1 font-light-grey4 rounded cursor--pointer bold' onClick={this.props.handleClose}>
              Cancel
            </div>
            <div className='py1 px2 font-white rounded bg-green ml1 cursor--pointer bold'>Done</div>
          </div>
        </div>
      </div>
    )
  }

  private handleTimeChanged = (hours: number, minutes: number) => {
    this.setState({ hours, minutes })
  }
}

export default SelectDate



// WEBPACK FOOTER //
// ./src/components/membership-request/SelectDate.tsx